if (!customElements.get('featured-collection')) {
    class FeaturedCollection extends HTMLElement {
      constructor() {
        super()

        let featuredCollectionSplideSlide = this.querySelectorAll('.featured-collection__splide__slide');

        let splide = new Splide(this.querySelector('.js-slider'), {
          type: 'loop',
          perMove: 1,
          pagination: false,
          arrows: true,
          slideFocus: false,
          perPage: 4,
          drag: true,
          gap: 0,
          speed: 800,
          breakpoints: {
            1600: {
              fixedWidth: '355px'
            },
            650: {
              gap: 16,
              fixedWidth: '218px'
            }
          },
        });

        splide.mount();
      }
    }

    customElements.define('featured-collection', FeaturedCollection)
}
